import PropTypes from "prop-types";
import { Helmet } from "react-helmet-async";
import { forwardRef } from "react";
import { Link as RouterLink } from "react-router-dom";
import { Icon } from "@iconify/react";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import { useTheme } from "@mui/material/styles";
import plusFill from "@iconify/icons-eva/plus-fill";
import Globe from "@iconify/icons-eva/globe-outline"

// ----------------------------------------------------------------------

const Page = forwardRef(
  (
    {
      children,
      title = "",
      path,
      action,
      actionButtonText = "",
      bulkButtonText = "",
      addCategoryText = "",
      ocpiOnboardingText = "",
      showBulkButton = false,
      showOcpiOnboardingButton = false,
      actions = [], // <-- new array prop
      bulkAction,
      categoryAction,
      sx = {},
      ...other
    },
    ref
  ) => {
    const theme = useTheme();
    const defaultBackground = theme.palette.mode === "light"
      ? theme.palette.gradients.dashboardCanvas
      : "none";

    return (
      <Box
        ref={ref}
        sx={{
          minHeight: "100%",
          backgroundColor: theme.palette.background.default,
          backgroundImage: defaultBackground,
          backgroundAttachment: theme.palette.mode === "light" ? "fixed" : "initial",
          backgroundSize: "cover",
          backgroundPosition: "center",
          paddingBottom: theme.spacing(3),
          ...sx,
        }}
        {...other}
      >
        <Helmet>
          <title>{title}</title>
        </Helmet>
      <Container
        maxWidth="xl"
        sx={{
          "@media screen and (min-width:600px)": { padding: "10px" },
          backgroundColor: "transparent",
        }}
      >
        {actions.length > 0 && (
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="end"
            spacing={2}
            mb={5}
          >
            {showOcpiOnboardingButton && 
            <Button variant="outlined" component={RouterLink} to="/ocpi/partners/onboard"  startIcon={<Icon icon={Globe} />}>
              {ocpiOnboardingText}
            </Button>}
            {showBulkButton && 
            <Button variant="contained" {...(showBulkButton && { onClick: () => bulkAction() })} startIcon={<Icon icon={plusFill} />}>
              {bulkButtonText}
            </Button>}
            {addCategoryText && (
              <Button
                variant="contained"
                onClick={categoryAction}
                startIcon={<Icon icon={plusFill} />}
              >
                {addCategoryText}
              </Button>
            )}
            {actions.map(({ path, action, text, icon = "eva:plus-fill" }, index) => (
              <Button
                key={index}
                variant="contained"
                {...(path && { to: path, component: RouterLink })}
                {...(action && { onClick: action })}
                startIcon={<Icon icon={icon} />}
              >
                {text}
              </Button>
            ))}
          </Stack>
        )}
        {children}
      </Container>
      </Box>
    );
  }
);


Page.propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.string,
};

export default Page;
